(() => {
  const initCookhouseNotesLightbox = () => {
    const lightbox = document.querySelector('.d2c-cookhouse-notes-lightbox');
    if (!lightbox || lightbox.dataset.initialized === 'true') return;
    lightbox.dataset.initialized = 'true';

    const image = lightbox.querySelector('img');
    const close = lightbox.querySelector('.d2c-cookhouse-notes-lightbox__close');
    const stage = lightbox.querySelector('.d2c-cookhouse-notes-lightbox__stage');
    const scroller = lightbox.querySelector('.d2c-cookhouse-notes-lightbox__scroller');
    const caption = lightbox.querySelector('.d2c-cookhouse-notes-lightbox__caption');
    const controls = lightbox.querySelectorAll('[data-lightbox-mode]');
    let isZoomed = false;

    const setMode = (zoomed) => {
      isZoomed = zoomed;
      lightbox.classList.toggle('is-zoomed', isZoomed);
      controls.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.lightboxMode === (isZoomed ? 'zoom' : 'fit')));
      });
    };

    const closeLightbox = () => {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('d2c-cookhouse-notes-lightbox-open');
      setMode(false);
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('.d2c-cookhouse-notes__image-link');
      if (!link) return;

      const source = link.getAttribute('href');
      const thumbnail = link.querySelector('img');
      if (!source || !thumbnail) return;

      event.preventDefault();
      image.src = source;
      image.alt = thumbnail.alt || 'Expanded Cookhouse Notes image';

      const figureCaption = link.closest('figure')?.querySelector('figcaption');
      caption.textContent = figureCaption ? figureCaption.textContent.trim() : '';
      caption.hidden = !caption.textContent;
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('d2c-cookhouse-notes-lightbox-open');
      setMode(false);

      requestAnimationFrame(() => {
        scroller.scrollTo({ top: 0, left: 0 });
        stage.focus();
      });
    });

    controls.forEach((button) => {
      button.addEventListener('click', () => {
        setMode(button.dataset.lightboxMode === 'zoom');
        requestAnimationFrame(() => scroller.scrollTo({ top: 0, left: 0 }));
      });
    });

    image.addEventListener('click', () => setMode(!isZoomed));
    close.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox || event.target === stage) closeLightbox();
    });
    document.addEventListener('keydown', (event) => {
      if (!lightbox.hidden && event.key === 'Escape') closeLightbox();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookhouseNotesLightbox, { once: true });
  } else {
    initCookhouseNotesLightbox();
  }
})();
